import React, { useEffect, useState } from 'react';
import Reveal from 'components/Reveal';
import { useNavigate } from 'react-router-dom';
import useUserStore from 'state/userStore';

const imageArr = [
  '/assets/images/carousel/one.jpg',
  '/assets/images/carousel/banner2.jpg',
  '/assets/images/carousel/two.jpg',
  '/assets/images/carousel/three.jpg',
];

const Carousel = () => {
  let timer: any;
  const [currentTab, setCurrentTab] = useState(0);
  const [currentBanner, setCurrentBanner] = useState(imageArr[currentTab]);

  const { user } = useUserStore();

  const updateTab = () => {
    timer = setInterval(() => {
      setCurrentTab((prevTab) =>
        prevTab < imageArr.length - 1 ? prevTab + 1 : 0
      );
      setCurrentBanner(
        imageArr[currentTab < imageArr.length - 1 ? currentTab + 1 : 0]
      );
    }, 8000);
  };

  const navigate = useNavigate();

  useEffect(() => {
    updateTab();

    return () => clearInterval(timer);
    //eslint-disable-next-line
  }, [currentTab]);

  return (
    <section className="relative flex h-[600px] w-full md:h-[900px]">
      <img
        src={currentBanner}
        alt="banner_image"
        className="z-10 h-full w-full object-cover brightness-50"
      />
      <Reveal>
        <div
          className="absolute inset-x-0 inset-y-[20%] z-30 mx-auto h-[350px] text-white md:inset-y-[40%]"
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // transition={{ delay: 1 }}
        >
          <div className="container m-auto px-5">
            <div className="my-auto flex">
              <div className="flex flex-col gap-4 lg:flex-row">
                <div className="my-auto w-full basis-3/4">
                  <div className="lg:w-[80%]">
                    <p className="text-[50px] leading-[50px]">
                      The Next Generation Investment <br /> Platform
                    </p>
                    <br />
                    <p className="my-2 text-lg leading-9">
                      Blockchain is a good crypto investment platform that makes
                      it easy to invest in the world's most popular
                      cryptocurrencies. With Blockchain, you can Buy, sell, and
                      trade cryptocurrencies with ease.
                    </p>
                    <div className="mt-3">
                      {!user ? (
                        <button
                          className="rounded-md bg-blue-500 px-5 py-2 text-lg hover:text-white"
                          onClick={() => navigate('/register')}
                        >
                          Get Started
                        </button>
                      ) : (
                        <button
                          className="rounded-md bg-blue-500 px-5 py-2 text-lg hover:text-white"
                          onClick={() =>
                            navigate(
                              user?.type === 'admin' ? '/admin' : '/dashboard'
                            )
                          }
                        >
                          Dashboard
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {/* <div className="basis-3/12">
                <img
                  src="/assets/icons/hero-rocket.svg"
                  alt="header"
                  className="hidden h-80 rounded-md md:block"
                />
              </div> */}
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
};

export default Carousel;
